<template>
  <b-navbar
    class="header d-print-none"
    :class="headerClass"
    fixed="top"
  >
    <b-nav>
      <b-nav-item>
        <a class="d-md-down-none px-2" href="#" @click="toggleSidebarMethod" id="barsTooltip">
          <i class="la la-bars la-lg" />
        </a>
        <b-tooltip target="barsTooltip" placement="bottom">
          Turn on/off
          <br />sidebar
          <br />collapsing
        </b-tooltip>
        <a class="fs-lg d-lg-none" href="#" @click="switchSidebarMethod">
          <span class="rounded rounded-lg bg-gray text-white d-md-none">
            <i class="la la-bars la-lg" />
          </span>
          <i class="la la-bars la-lg d-sm-down-none ml-4" />
        </a>
      </b-nav-item>
    </b-nav>
    <div class="mx-auto order-0">
      <span
        class="navbar-brand mx-auto"
      >{{ headerTitle }}</span>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target=".dual-collapse2"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <a class="navbar-brand d-md-none">
      <i class="fa fa-circle text-gray mr-n-sm" />
      <i class="fa fa-circle text-warning" />
      &nbsp;
      <h4 class="ml-1 mr-1">lemon bus</h4>&nbsp;
      <i class="fa fa-circle text-warning mr-n-sm" />
      <i class="fa fa-circle text-gray" />
    </a>
    <b-nav class="ml-auto">
      <b-nav-item style="pointer-events: none;">{{gitTag}}</b-nav-item>
      <b-nav-item-dropdown class="settings-dropdown d-sm-down-none" no-caret right>
        <template slot="button-content">
          <div class="mr-1">Hola,</div>
          <div class="font-weight-bold">{{username}}</div>
          <i class="la la-cog px-2" />
        </template>

        <b-dropdown-item-button @click="logout">
          <i class="la la-sign-out" /> Log Out
        </b-dropdown-item-button>
      </b-nav-item-dropdown>
    </b-nav>
  </b-navbar>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      client_id: "",
      gitTag: process.env.VUE_APP_GIT_TAG
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch("trekksoft/getTrekksoftClientName");
    } catch (ex) {
      this.error = "Failed to load data";
    } finally {
      this.client_id = this.trekksoftClient;
    }
  },
  methods: {
    ...mapActions("layout", [
      "toggleSidebar",
      "switchSidebar",
      "changeSidebarActive"
    ]),
    switchSidebarMethod() {
      if (!this.sidebarClose) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      } else {
        this.switchSidebar(false);
        const paths = this.$route.fullPath.split("/");
        paths.pop();
        this.changeSidebarActive(paths.join("/"));
      }
    },
    toggleSidebarMethod() {
      if (this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      } else {
        this.toggleSidebar();
        const paths = this.$route.fullPath.split("/");
        paths.pop();
        this.changeSidebarActive(paths.join("/"));
      }
    },
    logout() {
      window.localStorage.removeItem("t");
      this.$store
        .dispatch("filters/resetFilters")
        .then(window.localStorage.removeItem("filters"));
      this.$router.push("/login");
    }
  },
  computed: {
    ...mapState("layout", ["sidebarClose", "sidebarStatic"]),
    ...mapGetters([
      "trekksoftClient",
      "username",
      "filters",
      "suprazones",
      "groups",
      'currentSuprazone', 'currentGroup', 'filterDate', 
      'activeOption', 'activeTab', 'filterGroup', 'filterSuprazone'
    ]),
    plan() {
      return ` (${this.currentSuprazone != null ? this.currentSuprazone.name : ''} - ${this.currentGroup != null ? this.currentGroup.name : ''} - ${this.filterDate != null ? this.$moment(this.filterDate).format("DD/MM/YYYY") : ''})`
    },
    headerTitle() {
      if ( this.$route.path == '/app/dashboard') {
        return this.$route.name
      } else if ( this.$route.path == '/app/excursiones/excursiones') {
        return `Organización de buses de excursión ${this.plan}`
      } else if ( this.$route.path == '/app/excursiones/pickups') {
        return `Organización de buses de recogida ${this.plan}`
      } else if ( this.$route.path == '/app/excursiones/returns') {
        return `Organización de buses de devolución ${this.plan}`
      } else if ( this.$route.path == '/app/excursiones/reservas-sin-parada') {
        return this.$route.name + this.plan
      } else if ( this.$route.path == '/app/excursiones/reservas-sin-grupo') {
        return this.$route.name + this.plan
      } else if ( this.$route.path == '/app/excursiones/envio-planificacion') {
        return this.$route.name + this.plan
      } else if ( this.$route.path == '/app/excursiones/planification-dia' ) {
        return this.$route.name
      } else if ( this.$route.path == '/app/excursiones/check' ) {
        return this.$route.name
      } else {
        return this.$route.name
      }
    },
    headerClass() {
      if ( this.$route.path == '/app/dashboard') {
        return 'dashboard-page-top'
      } else if ( this.$route.path == '/app/excursiones/excursiones') {
        return 'excursion-page-top'
      } else if ( this.$route.path == '/app/excursiones/pickups') {
        return 'pickup-page-top'
      } else if ( this.$route.path == '/app/excursiones/returns') {
        return 'returns-page-top'
      } else if ( this.$route.path == '/app/excursiones/reservas-sin-parada') {
        return 'unassigned-page-top'
      } else if ( this.$route.path == '/app/excursiones/reservas-sin-grupo') {
        return 'no-group-page-top'
      } else if ( this.$route.path == '/app/excursiones/envio-planificacion') {
        return 'send-planning-page-top'
      } else if ( this.$route.path == '/app/excursiones/planificacion-dia' ) {
        return 'planing-day-page-top'
      } else if ( this.$route.path == '/app/excursiones/check' ) {
        return 'check-page-top'
      }else if ( this.$route.path == '/app/admin-panel') {
        return 'admin-panel-page-top'
      } else if ( this.$route.path == '/app/analytics-panel') {
        return 'analytics-panel-page-top'
      }
      return '' 
    }
    
  },
};
</script>

<style src="./Header.scss" lang="scss" scoped />